import content from "Content/images/documentType/content.svg";
import graph from "Content/images/documentType/graph.svg";
import map from "Content/images/documentType/map.svg";
import table from "Content/images/documentType/table.svg";
import report from "Content/images/documentType/report.svg";
import { DOCUMENT_TYPE } from "./documentType";
export default {
    [DOCUMENT_TYPE.GRAPH]: graph,
    [DOCUMENT_TYPE.TABLE]: table,
    [DOCUMENT_TYPE.MAP]: map,
    [DOCUMENT_TYPE.CONTENT]: content,
    5: report
};
